import revive_payload_client_4sVQNw7RlN from "/Users/abdalrahmansaadulla/Desktop/website/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/abdalrahmansaadulla/Desktop/website/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/abdalrahmansaadulla/Desktop/website/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/Users/abdalrahmansaadulla/Desktop/website/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/Users/abdalrahmansaadulla/Desktop/website/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Users/abdalrahmansaadulla/Desktop/website/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/Users/abdalrahmansaadulla/Desktop/website/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/Users/abdalrahmansaadulla/Desktop/website/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/abdalrahmansaadulla/Desktop/website/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_W86eSGFqyZ from "/Users/abdalrahmansaadulla/Desktop/website/node_modules/nuxt-viewport/dist/runtime/plugin.client.mjs";
import captcha_2ixTAsa90i from "/Users/abdalrahmansaadulla/Desktop/website/plugins/captcha.ts";
import form_client_TkIylfZzkE from "/Users/abdalrahmansaadulla/Desktop/website/plugins/form.client.ts";
import modal_UEFnUXzgTX from "/Users/abdalrahmansaadulla/Desktop/website/plugins/modal.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_W86eSGFqyZ,
  captcha_2ixTAsa90i,
  form_client_TkIylfZzkE,
  modal_UEFnUXzgTX
]